import { render, staticRenderFns } from "./InputField.vue?vue&type=template&id=27a23a5e&scoped=true&lang=pug&"
import script from "./InputField.vue?vue&type=script&lang=js&"
export * from "./InputField.vue?vue&type=script&lang=js&"
import style0 from "./InputField.vue?vue&type=style&index=0&id=27a23a5e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a23a5e",
  null
  
)

/* custom blocks */
import block0 from "./InputField.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports